import * as React from 'react';
import { Collapse, FormControl, FormGroup, FormLabel, IconButton, makeStyles } from '@material-ui/core';
import { neutral } from '../../../theme/colors';
import { fontFamilies } from '../../../theme/text';
import { ExpandLess } from '@material-ui/icons';
import clsx from 'clsx';
import TransactionIndicatorIcon from '../../../images/icons/transaction-indicator-icon';

interface Props {
  name: string;
  children: React.ReactNode;
  forceExpand?: boolean;
  constainsTransactionalAttribute?: boolean;
}

const useStyles = makeStyles({
  expand: {
    transform: 'rotate(0deg)',
    transition: 'transform 200ms'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  expandableTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  collapse: {
    paddingLeft: 30
  },
  fieldset: {
    padding: '16px 0',
    borderBottom: `1px solid ${neutral[300]}`,
    boxSizing: 'border-box',
    width: '100%',
    '&:first-of-type': {
      paddingTop: 0
    },
    '&:last-of-type': {
      border: 'none'
    },
    '&.collapsed': {
      border: `1px solid ${neutral[300]}`,
      padding: '2px 0',
      margin: '8px 0'
    }
  },
  formLabel: {
    color: neutral[600],
    fontFamily: fontFamilies.heading,
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'uppercase',
    float: 'left',
    display: 'flex'
  }
});

/**
 * Render a collapsible, titled group of attribute inputs in the segment attribute dialog menu
 */
const AttributeMenuCategory = ({ name, children, forceExpand, constainsTransactionalAttribute }: Props) => {
  const overrides = useStyles();
  const [collapsed, setCollapsed] = React.useState<boolean>(true);

  return (
    <FormControl component="fieldset" className={clsx(overrides.fieldset, collapsed && !forceExpand && 'collapsed')}>
      <div className={overrides.expandableTitle}>
        <IconButton
          size="small"
          onClick={() => {
            setCollapsed(!collapsed);
          }}
          disabled={forceExpand}
          className={clsx(overrides.expand, (!collapsed || forceExpand) && overrides.expandOpen)}
          aria-label={`expand ${name}`}
          aria-expanded={!collapsed || forceExpand}
        >
          <ExpandLess />
        </IconButton>
        <FormLabel component="legend" className={overrides.formLabel}>
          {constainsTransactionalAttribute && (
            <>
              <TransactionIndicatorIcon />
              &nbsp;
            </>
          )}
          {name}
        </FormLabel>
      </div>
      <Collapse in={!collapsed || forceExpand} className={overrides.collapse}>
        <FormGroup>{children}</FormGroup>
      </Collapse>
    </FormControl>
  );
};

export default AttributeMenuCategory;
